import { FC, useCallback } from 'react';

import LineButton from 'components/atoms/LineButton';
import {
  createTelemetryBeacon,
  sendTelemetryBeacon,
  setPersistentTracingIdentifiersInCookies,
} from 'utils/telemetry';
import {
  makeOAuthCookieNonce,
  Context,
  generateNonce,
  makeOAuthState,
} from '@z-components/utils/oauth';

/* eslint-disable-next-line prefer-destructuring */
const LINE_REDIRECT_URI = process.env.LINE_REDIRECT_URI;
/* eslint-disable-next-line prefer-destructuring */
const LINE_LOGIN_CHANNEL_ID = process.env.LINE_LOGIN_CHANNEL_ID;
/* eslint-disable-next-line prefer-destructuring */
const LINE_LOGIN_USE_POPUP = process.env.LINE_LOGIN_USE_POPUP;

interface Props {
  context: Context;
  onClick?: () => void;
}

const LineLogin: FC<Props> = ({ context, onClick }) => {
  const lineButtonClicked = useCallback(() => {
    onClick?.();
    const nonce = generateNonce();
    const cookie = makeOAuthCookieNonce({ nonce, url: process.env.DOMAIN ?? '' });
    document.cookie = cookie;
    const state = makeOAuthState({ context, provider: 'line', nonce });

    const lineConsentUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${
      LINE_LOGIN_CHANNEL_ID as string
    }&redirect_uri=${LINE_REDIRECT_URI as string}&scope=profile%20openid%20email&state=${state}`;

    setPersistentTracingIdentifiersInCookies();

    if (!LINE_LOGIN_USE_POPUP) {
      sendTelemetryBeacon(
        createTelemetryBeacon({
          action: 'OAuthLogin_navToConsentPage',
          context,
          provider: 'line',
        })
      );
      window.location.href = lineConsentUrl;
      return;
    }
  }, [context]);

  return <LineButton onClick={lineButtonClicked} />;
};

export type { Props as LineLoginProps };
export default LineLogin;
